export enum ChartMode {
    Absolute = "absolute",
    Percentage = "percentage",
    Unique = "unique",
}
